/**
 * This file holds actions. The actions commit mutations and can perform asynchronous operations.
 * Please refer to https://vuex.vuejs.org/guide/actions.html for more information
 */
import * as types from "./types";

const actions = {
  /**
   * This function initialize the state manager data
   * @param canvas
   */
  [types.INIT](context, canvas) {
    if (canvas) {
      context.commit(types.SET_CANVAS, canvas);
      context.commit(types.RESET);
      // Storing initial canvas state
      context.dispatch(types.STORE_STEP, {});
    }
  },
  /**
   * This function load data into the canvas from the provided step number
   * @param stepIndex
   */
  [types.LOAD_STEP](context, stepIndex) {
    const stepJson = context.state.steps[stepIndex];
    if (stepJson) {
      if (context.getters.isValidCanvas) {
        context.dispatch(types.LOAD_CANVAS_JSON, stepJson.data);
      } else {
        console.error("Invalid canvas object: loadFromJSON is not a function");
      }
    } else {
      console.error("Step data not found for index", stepIndex);
    }
  },
  /**
   * This function load json data into the canvas
   * @param context
   * @param jsonData
   */
  [types.LOAD_CANVAS_JSON](context, jsonData) {
    return new Promise((resolve, reject) => {
      try {
        const fabricCanvas = context.state.canvas;
        context.commit(types.SET_LOADING, true);
        fabricCanvas.loadFromJSON(jsonData, () => {
          const img = fabricCanvas.getObjects().find(item => item.type === "image");
          img.set({
            originX: "center",
            originY: "center",
            borderColor: "#666",
            cornerStrokeColor: "#666",
            cornerColor: "#ffffff",
            transparentCorners: false,
            borderScaleFactor: 1.5,
            lockScalingFlip: true,
            lockUniScaling: true
          });
          const placement = fabricCanvas.getObjects().find(item => item.type === "path");
          fabricCanvas.remove(placement);
          fabricCanvas.setActiveObject(img).requestRenderAll();
          context.commit(types.SET_LOADING, false);
          resolve();
        });
      } catch (e) {
        reject(e);
      }
    });
  },
  /**
   * This function stores the canvas current state into the steps array and increase the current step
   */
  [types.STORE_STEP](context, data = {}) {
    const { control = "" } = data;
    if (context.getters.isValidCanvas) {
      const stepJson = context.state.canvas.toJSON();
      const stepsLen = context.state.steps.length;
      const stepsLessOne = stepsLen - 1;
      if (stepsLen && stepsLessOne > context.state.currentStep) {
        context.state.steps.splice(context.state.currentStep - stepsLessOne);
      }
      context.commit(types.PUSH_STEP, { control, data: stepJson });
      context.commit(types.INCREASE_STEP);
    } else {
      throw new Error("Invalid canvas object: toJSON is not a function");
    }
  },
  /**
   * This function loads the next step data (from the current step) into the canvas and increase the current step
   */
  [types.NEXT_STEP](context) {
    const stepsCount = context.state.steps.length;
    if (stepsCount > 0 && context.state.currentStep < stepsCount - 1) {
      context.commit(types.INCREASE_STEP);
      context.dispatch(types.LOAD_STEP, context.state.currentStep);
    }
  },
  /**
   * This function loads the previous step data (from the current step) into the canvas and decrease the current step
   */
  [types.PREV_STEP](context) {
    const stepsCount = context.state.steps.length;
    if (stepsCount > 0 && context.state.currentStep > 0) {
      context.commit(types.DECREASE_STEP);
      context.dispatch(types.LOAD_STEP, context.state.currentStep);
    }
  },
  [types.TOGGLE_TILE_POPART_ON_STEP_CHANGE](context) {
    const { undos } = context.getters;
    const tileOrPopArt = undos.filter(
      ({ control }) => control === "tile" || control === "pop-art"
    );
    context.commit(types.APPLY_TILE_OR_POPART, tileOrPopArt.length > 0);
  }
};

export default actions;
